module.exports = __webpack_public_path__ + "prod/1.42.2/img/solutionLyl.de6cf7ac.jpg";